import {
    bpmsResourcesManagerApi,
    landingSettingsApi,
} from 'src/services/apiServices';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { RequestHelper } from 'src/utils/RequestHelper';

export class SettingsLandingStoreClass extends BasicStore<any> {
    itemDetailsFormKey =
        'embedded:deployment:forms/bo/bo-54-landing-page-settings.json';

    itemEditFormKey =
        'embedded:deployment:forms/bo/bo-55-edit-landing-page-settings.json';

    api: BasicStoreApi<any> = {
        loadItemForm: (formKey: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm({ formKey }, options),
            );
        },
        loadItem: (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                landingSettingsApi.getLandingPageSettings(options),
            );
        },
        updateItem: (_, data, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                landingSettingsApi.updateLandingPageSettings(
                    { landingPageSettingsRequest: data },
                    options,
                ),
            );
        },
    };
}

export const SettingsLandingStore = new SettingsLandingStoreClass();
